import { useUpdateInvoiceLineItem } from "@api/invoice.api";
import { InvoiceLineItem } from "@common/types/invoice";
import { LineItemClassesCell } from "@components/lineItems/LineItemClassesCell";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useCallback } from "react";
import { useScope } from "@state/scopeContext.lib";
import { useIsInvoiceLocked } from "@components/invoices/useIsInvoiceLocked";
import { INVOICE_LOCKED_FIELD_TOOLTIP } from "@components/invoices/invoiceLockedFieldTooltip";

export const ClassesCell = memo(
    ({ row }: CellContext<ViewTableFeatures, InvoiceLineItem, unknown>) => {
        const { workspaceId } = useScope();
        const updateInvoiceLineItem = useUpdateInvoiceLineItem();
        const isLocked = useIsInvoiceLocked(row.original.invoice);

        const handleClassesChange = useCallback(
            async (classIds: string[]) => {
                if (!workspaceId) {
                    return;
                }

                await updateInvoiceLineItem.mutateAsync({
                    workspaceId,
                    lineItemId: row.original.id,
                    classIds,
                });
            },
            [workspaceId, updateInvoiceLineItem, row.original.id],
        );

        return (
            <LineItemClassesCell
                lineItem={row.original}
                onUpdateClasses={handleClassesChange}
                readonly={isLocked}
                tooltip={INVOICE_LOCKED_FIELD_TOOLTIP}
            />
        );
    },
);
ClassesCell.displayName = "ClassesCell";
